module.exports = __webpack_public_path__ + "static/media/UserManualSiteStaffScanner.e58c7e6a.pdf";